import React, { useState, useEffect } from "react";
import { Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { formatCurrency, summary } from "../Utility/function";
import { stringDateTimeShort, stringYMDHMS3 } from "../Utility/dateTime";
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { Download, TimeControl } from "../components";
import { normalSort } from "../Utility/sort";
import { paymentNameMaps } from "../configs";
// import Download from "./Download";

const initialDetail = {
  thisTotalPrice:'', thisTotalDiscount:'', thisFine:'', thisServiceCharge:'', thisBeforeVat:'', thisVat:'', thisNet:'', thisDeliveryFee:''
}


function ReportVatScreen() {
  const { t } = useTranslation();
  const { selectedBill, startDate, endDate } = useSelector((state)=> state.bill)
  const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
  const [allPayment, setAllPayment] = useState([]);
  const [detail, setDetail] = useState(initialDetail);
  const {
    thisTotalPrice, thisTotalDiscount, 
    thisBeforeVat, thisVat, thisNet
  } = detail;

  useEffect(()=>{
    let fData = []
    let allPayment = []
        

      for(const item of normalSort('dateTime',[...selectedBill])){
        const { product, vatType, campaign, vatAmount = 0, payment, pointDiscount, manualDiscount = 0, productDiscount = 0 } = item;
        const totalPrice = summary(product,'totalPrice');
        const campaignDiscount = summary(campaign, 'discount');
        const totalDiscount = Number(pointDiscount.value) + campaignDiscount + Number(manualDiscount) + Number(productDiscount)

        const beforeVat = totalPrice - totalDiscount
        if(vatType==='Exclude'){
          fData.push({...item, totalPrice, beforeVat,totalDiscount})
        } else {
          fData.push({...item, totalPrice, beforeVat:beforeVat-Number(vatAmount),totalDiscount})
        }
        for(const { id, name, amount, change = 0 } of payment){
          let findPayment = allPayment.find(a=>a.id===id)
            if(findPayment){
              findPayment.amount += Number(amount) - Number(change)
            } else {
              if(name){
                allPayment.push({ id, name, amount:Number(amount) - Number(change) })
              } else {
                allPayment.push({ id, name:paymentNameMaps[id], amount:Number(amount) - Number(change) })
              }
            }
        }
      }

      fData = fData.map(a => ({
        ...a,
        payment: allPayment.map(b => {
          const { amount, change = 0 } = a.payment.find(c => c.id === b.id) || { amount:'', change:'' }
          return {
            ...b,
            amount: amount?Number(amount)-Number(change):0
          };
        })
      }));


      const { thisTotalPrice, thisTotalDiscount, thisBeforeVat, thisVat, thisNet } = fData.reduce(
        ( acc, item )=>{
            acc.thisTotalPrice += Number(item.totalPrice);
            acc.thisTotalDiscount += Number(item.totalDiscount);
            acc.thisBeforeVat += Number(item.beforeVat);
            acc.thisVat += Number(item.vatAmount);
            acc.thisNet += Number(item.moneyMustPaid);
            return acc
        },
        { thisTotalPrice:0, thisTotalDiscount:0, thisBeforeVat:0, thisVat:0, thisNet:0 }
      )
      setDetail({
        thisTotalPrice:formatCurrency(thisTotalPrice), 
        thisTotalDiscount:formatCurrency(thisTotalDiscount), 
        thisBeforeVat:formatCurrency(thisBeforeVat), 
        thisVat:formatCurrency(thisVat), 
        thisNet:formatCurrency(thisNet), 
      })
      setAllPayment(allPayment)
      setCurrentDisplay(fData)
  },[selectedBill])
  

  const exportToXlsx = () => {
    // Define the headers
    const headers = [
      ["No.", "วันที่", "ใบเสร็จ", "ลูกค้า", "เลยประจำตัวผู้เสียภาษี", "ยอดสินค้า", "ส่วนลด", "ยอดก่อนภาษี", "ภาษี", "ยอดสุทธิ", ...allPayment.map(a=>a.name)]
    ];
  
    // Map the data from the table
    const data = currentDisplay.map((item, index) => [
      index + 1,
      stringDateTimeShort(item.dateTime),
      item.receiptNumber,
      item.taxNumber ? item?.taxCustomer?.name : 'ลูกค้า',
      item.taxNumber ? item?.taxCustomer?.taxNumber : '-',
      formatCurrency(item.totalPrice),
      formatCurrency(item.totalDiscount),
      formatCurrency(item.beforeVat),
      formatCurrency(item.vatAmount),
      formatCurrency(item.moneyMustPaid),
      ...item.payment.map(a=>a.amount)
    ]);
  
    // Add the total row with "รวม" spanning two columns
    data.push([
      "รวม", "", "", "", "", // These will be merged
      thisTotalPrice,
      thisTotalDiscount,
      thisBeforeVat,
      thisVat,
      thisNet,
      ...allPayment.map(a=>a.amount)
    ]);
  
    // Create the worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "รายงานภาษีขาย");
  
    // Merge "รวม" over two columns (A12:B12 if it's row 12)
    worksheet["!merges"] = [
      { s: { r: data.length, c: 0 }, e: { r: data.length, c: 4 } } // Merge first two cells of last row
    ];
  
    // Trigger file download
    XLSX.writeFile(workbook, `รายงานภาษีขาย ${stringYMDHMS3(startDate)} - ${stringYMDHMS3(endDate)}.xlsx`);
  };



  return (
    <div  >
        <h1>รายงานภาษีขาย</h1>
        
        <TimeControl/>
        <div style={styles.container} >
          <Download exportToXlsx={exportToXlsx} />
        </div>
        <Row>
                <Table striped bordered hover responsive  variant="light" style={styles.container2}  >
                    <thead  >
                    <tr>
                        <th style={styles.container3}>{t('vat.no')}</th>
                        <th style={styles.container4}>{t('vat.date')}</th>
                        <th style={styles.container4}>{t('vat.receiptNumber')}</th>
                        <th style={styles.container4}>{t('vat.customer')}</th>
                        <th style={styles.container4}>{t('vat.taxNumber')}</th>
                        <th style={styles.container4}>{t('reportCancel.saleItem')}</th>
                        <th style={styles.container4}>{t('reportDiscount.discount')}</th>
                        <th style={styles.container4}>{t('vat.beforeVat')}</th>
                        <th style={styles.container4}>{t('vat.vatAmount')}</th>
                        <th style={styles.container4}>{t('vat.net')}</th>
                        {allPayment.map((a,i)=>{
                          return <th key={a.id} style={styles.container4}>{a.name}</th>
                        })}
                    </tr>
                  </thead>
                  <tbody  >
                    {currentDisplay.map((item, index) => {
                        const { dateTime, receiptNumber, taxNumber, vatAmount, moneyMustPaid, totalPrice, fine, serviceCharge, beforeVat, totalDiscount, payment, deliveryFee = 0 } = item;
                        return <tr  key={index} >
                                    <td style={styles.container5} >{index+1}.</td>
                                    <td style={styles.container5} >{stringDateTimeShort(dateTime)}</td>
                                    <td style={styles.container5} >{receiptNumber}</td>
                                    {taxNumber
                                        ?<>
                                        <td style={styles.container5} >{item?.taxCustomer?.name}</td>
                                        <td style={styles.container5} >{item?.taxCustomer?.taxNumber}</td>
                                        </>
                                        :<>
                                        <td style={styles.container5} >{t('vat.customer')}</td>
                                        <td style={styles.container5} >-</td>
                                        </>
                                    }
                                    <td style={styles.container5} >{formatCurrency(totalPrice)}</td>
                                    <td style={styles.container5} >{formatCurrency(totalDiscount)}</td>
                                    <td style={styles.container5} >{formatCurrency(beforeVat)}</td>
                                    <td style={styles.container5} >{formatCurrency(vatAmount)}</td>
                                    <td style={styles.container5} >{formatCurrency(moneyMustPaid)}</td>
                                    {payment.map((a,i)=>{
                                      return <td key={a.id} style={styles.container4}>{formatCurrency(a.amount)}</td>
                                    })}
                                </tr>
                    })}
                    <tr>
                      <td style={styles.container5} colSpan='5' >{t('summary.total')}</td>
                      <td style={styles.container5} >{thisTotalPrice}</td>
                      <td style={styles.container5} >{thisTotalDiscount}</td>
                      <td style={styles.container5} >{thisBeforeVat}</td>
                      <td style={styles.container5} >{thisVat}</td>
                      <td style={styles.container5} >{thisNet}</td>
                      {allPayment.map((a,i)=>{
                        return <td key={a.id} style={styles.container4}>{formatCurrency(a.amount)}</td>
                      })}
                    </tr>
                  </tbody>
                </Table>
              </Row>
              
    </div>
  );
};

const styles = {
  container : {
    display:'flex',justifyContent:'flex-end', marginBottom:10
  },
  container2 : {
    marginLeft:'1rem'
  },
  container3 : {
    width: '10%',  textAlign:'center'
  },
  container4 : {
    width: '10%', minWidth:'180px', textAlign:'center'
  },
  container5 : {
    textAlign:'center'
  }
}

export default ReportVatScreen;
